import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  openAnnotationDialog,
  closeAnnotationDialog,
  openASIFilterDialog,
  closeASIFilterDialog,
  openCaseDetailsDialog,
  closeCaseDetailsDialog,
  openClipDetailsDialog,
  closeClipDetailsDialog,
  openCloneDialog,
  closeCloneDialog,
  openClipImportWarningDialog,
  closeClipImportWarningDialog,
  openCombineClipsDialog,
  closeCombineClipsDialog,
  openDeleteCaseDialog,
  closeDeleteCaseDialog,
  openEditorDAWFineTuneDialog,
  closeEditorDAWFineTuneDialog,
  openExtractDialog,
  closeExtractDialog,
  openFFTSettingsDialog,
  closeFFTSettingsDialog,
  openGlimpseModelLengthDialog,
  closeGlimpseModelLengthDialog,
  openNLMSFilterDialog,
  closeNLMSFilterDialog,
  openSingleChannelActiveDialog,
  closeSingleChannelActiveDialog,
  openSngFilterDialog,
  closeSngFilterDialog,
  openSngFilterDialogNEW,
  closeSngFilterDialogNEW,
  openStoiResultsDialog,
  closeStoiResultsDialog,
  openStipaDialog,
  closeStipaDialog,
  openSyncDialog,
  closeSyncDialog,
  openSyncSelectedDialog,
  closeSyncSelectedDialog,
  openUntaggedRegionsDialog,
  closeUntaggedRegionsDialog,
} from ".";

export const useModals = () => {
  const dispatch = useDispatch();
  const dialogState = useSelector((state) => state.dialogs);

  // This is used to determine if any modal is open to not interefere with
  // the spacebar functionality in the wavesurfer player.
  const modalIsOpen = useSelector(
    (state) =>
      state.dialogs.showAnnotationDialog ||
      state.dialogs.showASIFilterDialog ||
      state.dialogs.showExtractDialog ||
      state.dialogs.showClipDetailsDialog ||
      state.dialogs.showNLMSFilterDialog ||
      state.dialogs.showSingleChannelActiveDialog ||
      state.dialogs.showSngFilterDialog ||
      state.dialogs.showSngFilterDialogNEW ||
      state.dialogs.showSyncDialog ||
      state.dialogs.showSyncSelectedDialog,
  );

  const handleOpenAnnotation = useCallback(() => {
    return dispatch(openAnnotationDialog());
  }, [dispatch]);

  const handleCloseAnnotation = useCallback(() => {
    return dispatch(closeAnnotationDialog());
  }, [dispatch]);

  const handleOpenASIFilter = useCallback(() => {
    return dispatch(openASIFilterDialog());
  }, [dispatch]);

  const handleCloseASIFilter = useCallback(() => {
    return dispatch(closeASIFilterDialog());
  }, [dispatch]);

  const handleOpenCaseDetails = useCallback(
    (caseId) => {
      return dispatch(openCaseDetailsDialog(caseId));
    },
    [dispatch],
  );

  const handleCloseCaseDetails = useCallback(() => {
    return dispatch(closeCaseDetailsDialog());
  }, [dispatch]);

  const handleOpenClipDetails = useCallback(
    (clipId) => {
      return dispatch(openClipDetailsDialog(clipId));
    },
    [dispatch],
  );

  const handleCloseClipDetails = useCallback(() => {
    return dispatch(closeClipDetailsDialog());
  }, [dispatch]);

  const handleOpenClipImportWarning = useCallback(() => {
    return dispatch(openClipImportWarningDialog());
  }, [dispatch]);

  const handleCloseClipImportWarning = useCallback(() => {
    return dispatch(closeClipImportWarningDialog());
  }, [dispatch]);

  const handleOpenClone = useCallback(() => {
    return dispatch(openCloneDialog());
  }, [dispatch]);

  const handleCloseClone = useCallback(() => {
    return dispatch(closeCloneDialog());
  }, [dispatch]);

  const handleOpenCombineClips = useCallback(() => {
    return dispatch(openCombineClipsDialog());
  }, [dispatch]);

  const handleCloseCombineClips = useCallback(() => {
    return dispatch(closeCombineClipsDialog());
  }, [dispatch]);

  const handleOpenDeleteCase = useCallback(
    (caseId) => {
      return dispatch(openDeleteCaseDialog(caseId));
    },
    [dispatch],
  );

  const handleCloseDeleteCase = useCallback(() => {
    return dispatch(closeDeleteCaseDialog());
  }, [dispatch]);

  const handleOpenEditorDAWFineTune = useCallback(() => {
    return dispatch(openEditorDAWFineTuneDialog());
  }, [dispatch]);

  const handleCloseEditorDAWFineTune = useCallback(() => {
    return dispatch(closeEditorDAWFineTuneDialog());
  }, [dispatch]);

  const handleOpenFFTSettings = useCallback(() => {
    return dispatch(openFFTSettingsDialog());
  }, [dispatch]);

  const handleCloseFFTSettings = useCallback(() => {
    return dispatch(closeFFTSettingsDialog());
  }, [dispatch]);

  const handleOpenExtract = useCallback(() => {
    return dispatch(openExtractDialog());
  }, [dispatch]);

  const handleCloseExtract = useCallback(() => {
    return dispatch(closeExtractDialog());
  }, [dispatch]);

  const handleOpenGlimpseModelLength = useCallback(() => {
    return dispatch(openGlimpseModelLengthDialog());
  }, [dispatch]);

  const handleCloseGlimpseModelLength = useCallback(() => {
    return dispatch(closeGlimpseModelLengthDialog());
  }, [dispatch]);

  const handleOpenNLMSFilter = useCallback(() => {
    return dispatch(openNLMSFilterDialog());
  }, [dispatch]);

  const handleCloseNLMSFilter = useCallback(() => {
    return dispatch(closeNLMSFilterDialog());
  }, [dispatch]);

  const handleOpenSingleChannelActive = useCallback(() => {
    return dispatch(openSingleChannelActiveDialog());
  }, [dispatch]);

  const handleCloseSingleChannelActive = useCallback(() => {
    return dispatch(closeSingleChannelActiveDialog());
  }, [dispatch]);

  const handleOpenSng = useCallback(() => {
    return dispatch(openSngFilterDialog());
  }, [dispatch]);

  const handleCloseSng = useCallback(() => {
    return dispatch(closeSngFilterDialog());
  }, [dispatch]);

  const handleOpenSngNEW = useCallback(() => {
    return dispatch(openSngFilterDialogNEW());
  }, [dispatch]);

  const handleCloseSngNEW = useCallback(() => {
    return dispatch(closeSngFilterDialogNEW());
  }, [dispatch]);

  const handleOpenStipa = useCallback(
    (clipId) => {
      return dispatch(openStipaDialog(clipId));
    },
    [dispatch],
  );

  const handleCloseStipa = useCallback(() => {
    return dispatch(closeStipaDialog());
  }, [dispatch]);

  const handleOpenStoiResults = useCallback(
    (clipId) => {
      return dispatch(openStoiResultsDialog(clipId));
    },
    [dispatch],
  );

  const handleCloseStoiResults = useCallback(() => {
    return dispatch(closeStoiResultsDialog());
  }, [dispatch]);

  const handleOpenSync = useCallback(() => {
    return dispatch(openSyncDialog());
  }, [dispatch]);

  const handleCloseSync = useCallback(() => {
    return dispatch(closeSyncDialog());
  }, [dispatch]);

  const handleOpenSyncSelected = useCallback(() => {
    return dispatch(openSyncSelectedDialog());
  }, [dispatch]);

  const handleCloseSyncSelected = useCallback(() => {
    return dispatch(closeSyncSelectedDialog());
  }, [dispatch]);

  const handleOpenUntaggedRegions = useCallback(() => {
    return dispatch(openUntaggedRegionsDialog());
  }, [dispatch]);

  const handleCloseUntaggedRegions = useCallback(() => {
    return dispatch(closeUntaggedRegionsDialog());
  }, [dispatch]);

  return {
    // State
    modalIsOpen,
    showAnnotationDialog: dialogState.showAnnotationDialog,
    showASIFilterDialog: dialogState.showASIFilterDialog,
    showCaseDetailsDialog: dialogState.showCaseDetailsDialog,
    showClipDetailsDialog: dialogState.showClipDetailsDialog,
    showCloneDialog: dialogState.showCloneDialog,
    showClipImportWarningDialog: dialogState.showClipImportWarningDialog,
    showCombineClipsDialog: dialogState.showCombineClipsDialog,
    showDeleteCaseDialog: dialogState.showDeleteCaseDialog,
    showEditorDAWFineTuneDialog: dialogState.showEditorDAWFineTuneDialog,
    showExtractDialog: dialogState.showExtractDialog,
    showFFTSettingsDialog: dialogState.showFFTSettingsDialog,
    showNLMSFilterDialog: dialogState.showNLMSFilterDialog,
    showSingleChannelActiveDialog: dialogState.showSingleChannelActiveDialog,
    showSngFilterDialog: dialogState.showSngFilterDialog,
    showSngFilterDialogNEW: dialogState.showSngFilterDialogNEW,
    showGlimpseModelLengthDialog: dialogState.showGlimpseModelLengthDialog,
    showStoiResultsDialog: dialogState.showStoiResultsDialog,
    showStipaDialog: dialogState.showStipaDialog,
    showSyncDialog: dialogState.showSyncDialog,
    showSyncSelectedDialog: dialogState.showSyncSelectedDialog,
    showUntaggedRegionsDialog: dialogState.showUntaggedRegionsDialog,
    // This is used to get the caseId for the case details dialog.
    // It is necessary for the cases page to tell mui to only reference a
    // specific case.
    caseDetailsCaseId: dialogState.caseDetailsCaseId,
    // This is used to get the clipId for the clip details dialog.
    // It is necessary for the clips page to tell mui to only reference a
    // specific clip.
    clipDetailsClipId: dialogState.clipDetailsClipId,

    // Actions
    openAnnotationDialog: handleOpenAnnotation,
    closeAnnotationDialog: handleCloseAnnotation,
    openASIFilterDialog: handleOpenASIFilter,
    closeASIFilterDialog: handleCloseASIFilter,
    openCaseDetailsDialog: handleOpenCaseDetails,
    closeCaseDetailsDialog: handleCloseCaseDetails,
    openClipDetailsDialog: handleOpenClipDetails,
    closeClipDetailsDialog: handleCloseClipDetails,
    openClipImportWarningDialog: handleOpenClipImportWarning,
    closeClipImportWarningDialog: handleCloseClipImportWarning,
    openCloneDialog: handleOpenClone,
    closeCloneDialog: handleCloseClone,
    openCombineClipsDialog: handleOpenCombineClips,
    closeCombineClipsDialog: handleCloseCombineClips,
    openEditorDAWFineTuneDialog: handleOpenEditorDAWFineTune,
    closeEditorDAWFineTuneDialog: handleCloseEditorDAWFineTune,
    openDeleteCaseDialog: handleOpenDeleteCase,
    closeDeleteCaseDialog: handleCloseDeleteCase,
    openExtractDialog: handleOpenExtract,
    closeExtractDialog: handleCloseExtract,
    openFFTSettingsDialog: handleOpenFFTSettings,
    closeFFTSettingsDialog: handleCloseFFTSettings,
    openNLMSFilterDialog: handleOpenNLMSFilter,
    closeNLMSFilterDialog: handleCloseNLMSFilter,
    openSingleChannelActiveDialog: handleOpenSingleChannelActive,
    closeSingleChannelActiveDialog: handleCloseSingleChannelActive,
    openSngFilterDialog: handleOpenSng,
    closeSngFilterDialog: handleCloseSng,
    openSngFilterDialogNEW: handleOpenSngNEW,
    openGlimpseModelLengthDialog: handleOpenGlimpseModelLength,
    closeGlimpseModelLengthDialog: handleCloseGlimpseModelLength,
    closeSngFilterDialogNEW: handleCloseSngNEW,
    openStipaDialog: handleOpenStipa,
    closeStipaDialog: handleCloseStipa,
    openStoiResultsDialog: handleOpenStoiResults,
    closeStoiResultsDialog: handleCloseStoiResults,
    openSyncDialog: handleOpenSync,
    closeSyncDialog: handleCloseSync,
    openSyncSelectedDialog: handleOpenSyncSelected,
    closeSyncSelectedDialog: handleCloseSyncSelected,
    openUntaggedRegionsDialog: handleOpenUntaggedRegions,
    closeUntaggedRegionsDialog: handleCloseUntaggedRegions,
  };
};
